import React from 'react';
import { Link } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import AppIcons from '../../assets/images/icons/index';
import AppLayout from '../../layouts/app/AppLayout';
import ForgotPasswordForm from './forms/forgotPassword.form';



const ForgotPasswordPage = () => {
    const pageName = 'Forgot password';
    return (
        <AppLayout
            isLoadHeader={false}
            isLoadFooter={false}
            pageName={pageName}
            bodyClassName='forgotpasswrd auth-layout'
        >

            <div className='auth-page-layout f-wrp'>
                <div className='container-fluid'>
                    <div className='flex-box'>
                        <div className='form-sec-wrp'>
                            <Link to={'/'} className='auth-logo'><img src={AppIcons.logo} alt='register' /></Link>
                            <div className='auth-form'>
                                <Stack className='form-tile'>
                                    <Typography variant="h3" fontStyle={'normal'} fontWeight={'400'}>Forgot password</Typography>
                                    <Typography variant="h4" fontStyle={'normal'} fontWeight={'400'}>You will receive instructions to resetting your password</Typography>
                                </Stack>
                                <ForgotPasswordForm />
                            </div>
                        </div>
                        <div className='form-img-wrp'>
                            <span><img src={AppIcons.registerBG} alt='register' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default ForgotPasswordPage;